import type React from "react";
import {memo, useMemo} from "react";

import {generateHours} from "../../utils/date";
import SelectGeneric from "../SelectGeneric";

type Props = {
    className?: string;
    minutes?: number;
    onChange: (value: number) => void;
};

const SelectHour: React.FC<Props> = ({className, minutes, onChange}) => {
    const options = useMemo(() => {
        const opts = generateHours();
        return opts;
    }, []);

    const selectedHourValue =
        minutes !== undefined && minutes >= 0
            ? ((Math.floor(minutes / 60) + 11) % 12) + 1
            : undefined;

    return (
        <SelectGeneric
            className={className}
            options={options}
            placeholder="Select hour..."
            testID="select-hour"
            value={selectedHourValue}
            onChange={onChange}
        />
    );
};

export default memo(SelectHour);
